import get from 'lodash/get';
import { feedBack } from '../actionTypes';

const startFetchingFeedBackListWidgets = () => ({
  type: feedBack.START_FETCHING_FEEDBACK_WIDGETS
});

const successFetchingFeedBackListWidgets = payload => ({
  type: feedBack.SUCCESS_FETCHING_FEEDBACK_WIDGETS,
  payload
});

const errorFetchingFeedBackListWidgets = payload => ({
  type: feedBack.FAILURE_FETCHING_FEEDBACK_WIDGETS,
  payload
});

export const clearFeedBackListWidgets = payload => ({
  type: feedBack.CLEAR_FEEDBACK_WIDGETS,
  payload
});


export const fetchFeedBackListWidgets = () => dispatch => {
  dispatch(clearFeedBackListWidgets())
  dispatch(startFetchingFeedBackListWidgets())
  dispatch({
    hmsFetchConfig: {
      path: '/hms_ms/api/v1/generic/campaign_page_widgets_v2',
      method: 'POST',
      queryParams: {
        page_type: 'medallia_feedback_list_config',
        campaign: 'muo',
        clear_cache: true
      },
    },
    onSuccess: ({ data }) => {
      const feedback_widget_data = get(data, 'data.widget_list[0]', []);
      dispatch(successFetchingFeedBackListWidgets({ feedback_widget_data }));
    },
    onError: ({ error }) => {
      dispatch(errorFetchingFeedBackListWidgets({ error }));
    }
  });
};

